<template>
    <ul class="forum-post-result-list">
        <li
            :key="post.id"
            v-for="post in posts">
            <ForumPostResult
                :post="post"
                :thread="post.thread">
            </ForumPostResult>
        </li>
    </ul>
</template>

<script>
    // ForumPostResultList: a simple list of forum post results. This pairs well
    // with the ForumThreadList for use in the forum search component.

    import ForumPostResult from './post-result';

    export default {
        props: {
            posts: {
                type: Array, // ForumPostSearchResult (see forum service)
                required: true,
            },
        },

        components: {
            ForumPostResult,
        },
    }
</script>

<style lang="scss" scoped>
    ul.forum-post-result-list {
        margin: 0;
        padding: 0;

        // Extra specificity needed in selector for this
        border-bottom: 1px solid #333;
    }

    li {
        list-style: none;

        &:first-of-type {
            .forum-post {
                margin-top: 0;
            }
        }

        .forum-post-result {
            border-top: 1px solid #333;
            margin-left: 0;
            margin-right: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// post-result-list.vue?313cda0d